<label [class]="styled" for="picture__input" tabIndex="0">
    <span class="picture__image img-fluid"></span>
  </label>
<input type="file" name="picture__input" class="img-fluid" id="picture__input">
